var _style, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1728px",
    height: "1296px",
    viewBox: "0 0 1728 1296",
    style: {
      enableBackground: "new 0 0 1728 1296"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.boy_st0{fill:#FF3C00;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.boy_st1{stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st2{fill:#FFFFFF;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st3{fill:#FF3C00;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.boy_st4{fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st5{fill:#E7A882;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st6{fill:#000361;stroke:#000000;stroke-miterlimit:10;}\n\t.boy_st7{fill:#0000FF;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st8{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\n\t.boy_st9{fill:#0000FF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.boy_st10{fill:#B58567;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st11{display:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st12{display:none;fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st13{fill:#8F7C50;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.boy_st14{fill:#CCB276;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st15{fill:#0000E3;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st16{fill:#FF0000;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st17{fill:#E0C380;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st18{fill:#FF3C00;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st19{display:none;fill:#FF9CB3;stroke:#FFB0DD;stroke-width:2;stroke-miterlimit:10;}\n\t.boy_st20{fill:#FF85A1;stroke:#CF6D99;stroke-width:2;stroke-miterlimit:10;}\n\t.boy_st21{fill:#0F0606;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st22{display:none;}\n\t.boy_st23{display:inline;fill:#FFFFFF;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st24{display:inline;fill:#FF3C00;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st25{display:inline;fill:#0000FF;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.boy_st26{fill:#0000FF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_7_shoes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "boy_st1",
    d: "M766.42,1155.82c1.09,10.83,2.29,21.99,6.54,32.57c33.13,4.05,67.09,2.64,97.18-4.26 c4.09-10.35,6-21.37,4.66-33.66C839.34,1150.43,803.87,1152.01,766.42,1155.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st1",
    d: "M1000.73,1155.82c-1.09,10.83-2.28,21.99-6.53,32.57c-33.06,4.05-66.94,2.64-96.97-4.26 c-4.08-10.35-5.99-21.37-4.65-33.66C927.97,1150.43,963.36,1152.01,1000.73,1155.82z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "boy_st2",
    d: "M1013.67,1129.66c3.37,13.64,4.45,27.77,3.19,41.71c-41.01,5.37-82.89,5.06-123.8-0.94 c-2.03-0.3-4.29-0.74-5.45-2.31c-0.93-1.27-0.88-2.92-0.8-4.45c0.66-11.73,1.32-23.46,1.98-35.19 c31.81-2.82,63.75-4.29,95.71-4.41C995.23,1124.04,1006.27,1124.2,1013.67,1129.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st3",
    d: "M888.42,1168.81l25.99,4.36l35.25,2.1l45.66-2.01l21.57-2.75l1.26-9.21c-10.03,2-29.05,6.64-94.44,3.32 c-16.47-0.84-28.29-3.58-36.44-4.75L888.42,1168.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st4",
    d: "M1013.67,1129.66c3.37,13.64,4.45,27.77,3.19,41.71c-41.01,5.37-82.89,5.06-123.8-0.94 c-2.03-0.3-4.29-0.74-5.45-2.31c-0.93-1.27-0.88-2.92-0.8-4.45c0.66-11.73,1.32-23.46,1.98-35.19 c31.81-2.82,63.75-4.29,95.71-4.41C995.23,1124.04,1006.27,1124.2,1013.67,1129.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st2",
    d: "M753.46,1129.66c-3.38,13.64-4.46,27.77-3.2,41.71c41.1,5.37,83.07,5.06,124.07-0.94 c2.04-0.3,4.3-0.74,5.46-2.31c0.94-1.27,0.89-2.92,0.8-4.45c-0.66-11.73-1.32-23.46-1.99-35.19 c-31.87-2.82-63.89-4.29-95.91-4.41C771.93,1124.04,760.87,1124.2,753.46,1129.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st3",
    d: "M879.49,1168.81l-25.99,4.36l-35.25,2.1l-45.66-2.01l-21.57-2.75l-1.26-9.21c10.03,2,29.05,6.64,94.44,3.32 c16.47-0.84,28.29-3.58,36.44-4.75L879.49,1168.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st4",
    d: "M753.46,1129.66c-3.38,13.64-4.46,27.77-3.2,41.71c41.1,5.37,83.07,5.06,124.07-0.94 c2.04-0.3,4.3-0.74,5.46-2.31c0.94-1.27,0.89-2.92,0.8-4.45c-0.66-11.73-1.32-23.46-1.99-35.19 c-31.87-2.82-63.89-4.29-95.91-4.41C771.93,1124.04,760.87,1124.2,753.46,1129.66z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_10"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "boy_st5",
    cx: 677.11,
    cy: 1030.62,
    rx: 35.81,
    ry: 35.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "boy_st5",
    cx: 1078.76,
    cy: 1023.75,
    rx: 35.81,
    ry: 35.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st6",
    d: "M1119.14,951.2c-12.96,6.85-29.3,8.17-43.86,9.87c-18.37,2.14-36.68,5.08-55.15,5.76 c-18.48,0.68-37.32-1-53.34-8.37c11.66-10.73,26.05-18.25,41.19-22.93c15.14-4.68,31.03-6.58,46.87-6.89 c11.41-0.23,22.87,0.36,34.07,2.51c4.96,0.95,9.9,2.22,14.41,4.49C1110.19,939.09,1117.14,944.87,1119.14,951.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st6",
    d: "M632.7,956.05c10.87,9.02,25.67,12.2,39,16.44c16.81,5.34,33.42,11.47,50.6,15.39 c17.18,3.93,35.15,5.61,51.52,1.19c-8.93-12.6-21.02-22.54-34.34-29.8c-13.31-7.27-27.85-11.94-42.63-15.04 c-10.64-2.24-21.49-3.68-32.38-3.55c-4.82,0.06-9.68,0.43-14.33,1.87C643.07,944.73,635.75,950.19,632.7,956.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st2",
    d: "M641.03,1012.91c3.92-37.12,14.51-73.52,31.09-106.96c6.69-13.49,14.51-26.71,25.55-36.95 c10.08-9.35,25.38-16.01,37.39-9.33c8.85,4.92,12.9,15.5,14.52,25.5c2.58,15.95,0.72,32.27-1.81,48.23 c-4.9,30.9-12.31,61.41-22.12,91.11c-0.87,2.63-1.82,5.36-3.83,7.26c-3.01,2.86-7.58,3.15-11.73,3.1 C684.08,1034.6,658.18,1027.46,641.03,1012.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st2",
    d: "M1110.77,1001.78c-3.93-37.12-14.53-73.52-31.14-106.96c-6.7-13.49-14.54-26.71-25.59-36.95 c-10.09-9.35-25.41-16.01-37.45-9.33c-8.87,4.92-12.92,15.5-14.54,25.5c-2.58,15.95-0.72,32.27,1.82,48.22 c4.91,30.9,12.33,61.41,22.16,91.11c0.87,2.63,1.82,5.36,3.83,7.26c3.02,2.86,7.59,3.15,11.75,3.1 C1067.65,1023.48,1093.6,1016.33,1110.77,1001.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st7",
    d: "M1031.67,1006.7c26.68,3.92,55.35-3.87,76.31-20.31c0.72,0.65,1.47,13.18,2.07,15.99 c-5.54,4.67-10.86,7.96-17.87,10.81s-18.39,6.69-25.82,8.16c-9.86,1.95-20.01,3.12-30.01,2.13L1031.67,1006.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st7",
    d: "M719.42,1017.28c-26.68,3.92-55.35-3.87-76.31-20.31c-1.08,4.04-1.47,13.18-2.07,15.99 c5.54,4.67,16.71,10.84,23.72,13.69c7.01,2.85,15.02,4.68,22.44,6.15c9.86,1.95,14.73,3.07,24.74,2.08L719.42,1017.28z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "boy_st2",
    d: "M744.13,760.64c-18.34,112.28-39.07,252.31-62.52,362.22c33.82,10.52,68.95,16.11,104.07,20.74 c92.62,12.19,188.78,17.55,280.11-16.71c-25.5-122.34-50-244.88-73.53-364.13C909.59,761.79,827.75,732.89,744.13,760.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st9",
    d: "M1055.79,1087.06c-120.13,42.63-246.45,32.37-365.76-5.52l-2.52,12.82c119.31,37.89,250.46,47.98,370.76,5.29 L1055.79,1087.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st0",
    d: "M1040.13,1000.54c-112.27,26.69-224.63,24.92-332.92-11.37l-3.96,21.43 c110.78,37.6,224.07,39.17,340.88,10.66L1040.13,1000.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 784.32,
    y: 769.04,
    className: "boy_st10",
    width: 182.46,
    height: 123.57
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "boy_st5",
    cx: 867.46,
    cy: 627.41,
    rx: 267,
    ry: 206
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "boy_st11",
    cx: 973.28,
    cy: 680.67,
    rx: 40.5,
    ry: 44.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "boy_st11",
    cx: 765.4,
    cy: 680.67,
    rx: 40.5,
    ry: 44.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st12",
    d: "M828.62,733.83c10.94,11.4,26.83,17.87,42.63,17.37s31.24-7.97,41.44-20.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st13",
    d: "M480.33,579.59c118.2,10.28,239.86-15.07,359.42-23.46c52.3-21.47,105.91-39.76,158.19-49.24 c2.01-2.25,5.62-2.44,8.38-1.21c2.76,1.23,4.84,3.58,6.74,5.92c9.25,11.42,16.5,24.63,25.73,36.46 c66.46,0.39,135.27,0.41,193.96-25.13c-13.13-11.14-84.21-20.65-126.52-27.01c-34.25-5.15-68.51-10.3-102.99-13.55 c-77.65-7.32-156.21-4.94-236.19,8.68c-14.32-0.11-28.3,3.97-42.15,7.64c-65.89,17.44-134.58,26.3-196.95,53.8 C513.37,558.92,497.21,569.83,480.33,579.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st1",
    d: "M604.14,661.66c80.25-9.71,153.87-43.14,224.74-84.84c-1.49,8.96-5.93,17.4-12.47,23.71 c61.62-11.15,108.75-41.2,154.89-85.46c34.07,54.52,99.78,95.74,162.46,113.85c3.59-45.41-16.17-90.86-47.62-123.8 s-73.65-54.22-117.54-66.4c-43.89-12.18-89.69-15.76-135.21-17.39c-11.74-0.42-23.62-0.7-35.07,1.91 c-10.18,2.32-19.7,6.85-29.12,11.35c-18.89,9.02-37.78,18.04-59.81,28.79c-44.1,24.97-86.36,63.15-100.38,112.14 c-2.39,8.34-5.69,25.88-5.69,25.88C598.89,619.92,602.28,640.45,604.14,661.66z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "boy_st14",
    d: "M671.29,472.71c6.06-81.14,65.78-155.61,143.67-179.15s168.86,5.38,218.85,69.58 c20.77,26.68,34.96,59.97,27.73,94.83c-58.87-7.25-118.49-2.13-177.58,3c-63.91,5.55-127.83,11.09-191.74,16.64 C683.67,478.35,675.05,479.09,671.29,472.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st15",
    d: "M671.29,472.71c6.06-81.14,48.13-85.42,126.02-108.96c77.88-23.54,141.71-20.63,216.48,0.55 c32.53,9.22,54.98,58.81,47.75,93.66c-58.87-7.25-122.81-20.13-181.9-15c-63.91,5.55-115.43-5.29-187.42,34.64 C684.71,481.77,675.05,479.09,671.29,472.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st16",
    d: "M678.23,434.58c37.76-18.63,80.03-26.19,121.96-30.49c72.44-7.44,145.83-5.74,217.84,5.1 c16.3,2.45,32.71,5.43,43.2,8.76c-11.17-32.23-31.55-61.25-55.94-82.15c-91.67-13.23-190.53-6.55-282.39,17.79 c-15.26,17.83-24.01,36.8-34.73,57.65C684.45,418.46,680.95,426.25,678.23,434.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st17",
    d: "M540.78,528.03c24.52-26.51,56.67-45.11,90.53-57.67c33.85-12.57,69.54-19.4,105.21-25.08 c83.49-13.29,167.99-16.54,248.85-16.5c53.76,4.29,143.55,20.92,194.1,64.62c-125.53-10.01-251.6-13.2-377.47-9.56 c-37.22,1.08-74.73,2.79-110.83,11.92C639.86,508.74,589.81,536.72,540.78,528.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st18",
    d: "M481.65,575.51c10.78-22.35,28.11-42.13,50.62-52.59c9.61-4.46,19.93-7.16,30.2-9.74 c194.96-48.91,398.45-63.65,592.46-38.13c27.4,6.19,52.88,20.58,73.34,44.63c-64.28-11.02-128.98-20.71-194.17-22.78 c-54.37-1.73-108.75,1.84-163.02,5.42C738.38,511.04,601.95,520.72,481.65,575.51z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "boy_st18",
    d: "M669.83,365.63c17.79-3.75,34.62-12.01,48.46-23.8c6.1,8.02,15.34,13.58,25.28,15.22 c-2.22,16.09-7.31,31.78-14.96,46.11c-0.58,1.09-1.21,2.21-2.23,2.89c-1.64,1.11-3.82,0.83-5.76,0.42 C698.65,401.87,679.2,386.52,669.83,365.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st18",
    d: "M998.71,341c1.48,19.41,6.34,38.56,14.31,56.32c0.57,1.27,1.22,2.61,2.42,3.32 c0.81,0.48,1.78,0.61,2.72,0.69c14.18,1.19,27.52-6.14,39.85-13.23c4.78-2.75,9.65-5.57,13.29-9.7c5.07-5.76,7.23-13.44,7-20.34 c-8.01,0.94-16.37,1.84-23.95-0.91c-2.64-0.96-5.11-2.34-7.56-3.72c-5.37-3.03-10.72-6.1-15.74-9.69 c-6.61-4.72-12.61-10.31-17.78-16.58C1009.72,333.71,998.27,335.23,998.71,341z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st18",
    d: "M854.36,335.74c-6.19,16.14-11.74,32.52-16.64,49.09c20.03,10.08,44.45,11.01,64.95,3.21 c-11.36-19.95-21.89-40.38-31.53-61.21C865.64,328.13,857.24,328.22,854.36,335.74z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "boy_st18",
    cx: 736.88,
    cy: 346.26,
    r: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "boy_st18",
    cx: 864,
    cy: 330.61,
    r: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "boy_st18",
    cx: 1002.87,
    cy: 333.24,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st18",
    d: "M807.76,251.89c-1.61-4.45-1.86-9.86,0.41-13.9c2.27-4.04,7.48-5.86,10.79-2.95 c-1.05-7,2.3-14.58,7.8-17.65c5.5-3.07,12.67-1.36,16.69,3.98c1.57-6.3,7.5-10.67,13.06-9.63c5.56,1.04,10.01,7.36,9.81,13.91 c4.5-5.11,12.17-5.1,17.43-1.08c2.17,1.66,4.05,3.97,4.98,6.8c0.93,2.83,0.82,6.2-0.62,8.71c5.13-0.75,10.49,3.04,12.28,8.69 c1.79,5.65-0.17,12.59-4.49,15.9c2.43-0.09,4.24,2.51,5.5,4.94c1.77,3.43,3.32,7.34,2.84,11.31 c-0.77,6.44-6.74,10.56-12.32,10.75c0.31,2.5-0.71,5.04-2.23,6.84c-1.52,1.81-3.49,2.99-5.48,4.02 c-4.87,2.53-11.16,4.05-15.06-0.19c-1.4,3.41-5.02,4.58-8.23,5.14c-3.52,0.61-7.13,0.92-10.62,0.1 c-3.49-0.82-6.87-2.89-8.92-6.28c-0.24-0.4-0.48-0.83-0.85-1.06c-1.36-0.84-2.43,1.47-3.34,2.92c-2.26,3.57-6.98,2.6-10.59,1.2 c-5.37-2.07-11.47-5.2-12.77-11.62c-0.11-0.53-0.2-1.12-0.55-1.48c-1-1.03-2.29,0.8-3.52,1.39c-1.36,0.65-2.85-0.34-4.08-1.28 c-3.67-2.84-7.67-6.28-8.29-11.36c-0.3-2.44,0.27-4.92,1.15-7.16c1.62-4.14,4.35-7.69,7.71-10.02c-2.01-1.19-2.69-4.33-2.06-6.85 C804.82,253.48,806.46,251.49,807.76,251.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_13"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "boy_st16",
    cx: 1166.62,
    cy: 566.99,
    rx: 15,
    ry: 14.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "boy_st16",
    cx: 577.62,
    cy: 610.88,
    rx: 15,
    ry: 14.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "boy_st16",
    cx: 522.68,
    cy: 610.88,
    rx: 18.11,
    ry: 16.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "boy_st16",
    cx: 1219.37,
    cy: 575.51,
    rx: 18.11,
    ry: 16.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st16",
    d: "M517.86,561.9c-1.57,11.77-0.99,23.83,1.72,35.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st16",
    d: "M1211.49,517.2c4.58,13.78,7.69,28.04,9.26,42.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st16",
    d: "M576.08,581.74c-0.04,4.62,0.27,9.25,0.93,13.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st16",
    d: "M1162.38,542.53c1.71,2.73,2.7,5.89,2.85,9.11"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "boy_st19",
    cx: 719.38,
    cy: 749.35,
    rx: 27.28,
    ry: 19.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "boy_st19",
    cx: 1031.67,
    cy: 741.2,
    rx: 27.28,
    ry: 19.69
  }), /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0279 -0.9996 0.9996 0.0279 248.2873 1754.5144)",
    className: "boy_st20",
    cx: 1026.23,
    cy: 749.6,
    rx: 19.21,
    ry: 28.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.385285e-03 -1 1 7.385285e-03 -52.9562 1445.8522)",
    className: "boy_st20",
    cx: 701.81,
    cy: 749.6,
    rx: 19.24,
    ry: 28.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0765 -0.9971 0.9971 0.0765 206.6948 1600.2327)",
    className: "boy_st21",
    cx: 967.2,
    cy: 688.54,
    rx: 47.93,
    ry: 38.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0765 -0.9971 0.9971 0.0765 16.1871 1399.8047)",
    className: "boy_st1",
    cx: 763.75,
    cy: 691.16,
    rx: 47.93,
    ry: 38.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st4",
    d: "M831.47,745.99c9.58,7.9,21.56,12.3,33.58,12.35c12.02,0.05,24.03-4.27,33.59-12.19"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boy_Left",
    className: "boy_st22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "boy_st23",
    d: "M700.48,831.66c-33.62,30.28-64.26,71.66-72.09,117.55c26.97-2.34,54.09-4.67,81.08-2.63 c27,2.05,68.11,12.2,92.87,27.12c27.73-30.93,61.42-56.49,100.05-74.32C842.08,859.36,772.11,834.04,700.48,831.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st24",
    d: "M699.42,806.74c16.5-7.53,35.51-7.3,53.45-4.64c40.85,6.05,79.57,24.01,112.04,49.51 c5.01,3.94,9.98,8.16,13.25,14.66c-6.11,7.41-13.1,14.1-22.1,20.13c-9.44-7.54-20.66-12.46-31.82-17.07 c-21.66-8.96-43.81-17.15-66.9-21.17c-23.09-4.02-50.1-9.99-72.43-0.83c-3.08-7.6-1.99-12.92-0.23-20.93 C686.62,817.5,691.95,810.14,699.42,806.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st25",
    d: "M816.86,957.35c-53.03-34.87-117.39-34.63-180.82-29.26c0,0-4.46,20.61-4.46,21.48 c29.28-2.48,71.57-4.63,89.26-1.41c30.33,5.53,53.85,11.28,81.97,25.54C807.65,966.66,811.45,963.23,816.86,957.35z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Boy_Right"
  }, /*#__PURE__*/React.createElement("path", {
    className: "boy_st2",
    d: "M1058.44,827.72c33.66,30.28,50.32,75.16,58.16,121.05c-27-2.34-54.15-4.67-81.18-2.63 c-27.03,2.05-54.17,8.7-78.96,23.62c-27.76-30.93-61.49-56.49-100.17-74.32C916.67,855.41,986.73,830.1,1058.44,827.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st2",
    d: "M693.11,832.44c-33.66,30.28-50.32,75.16-58.16,121.05c27-2.34,54.15-4.67,81.18-2.63s54.17,8.7,78.96,23.62 c27.76-30.93,61.49-56.49,100.17-74.32C834.88,860.13,764.82,834.82,693.11,832.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st18",
    d: "M1055,798.09c-16.84-7.42-35.8-6.29-53.57-2.58c-40.45,8.46-78.19,29.77-109.31,58.99 c-4.81,4.51-9.55,9.33-12.48,16.55c6.47,7.78,13.78,14.73,23.06,20.86c9.04-8.63,19.99-14.49,30.89-20.03 c21.16-10.74,42.85-20.67,65.69-26.1c22.84-5.43,49.49-13.17,72.23-4.24c2.69-8.41,1.34-14.13-0.82-22.76 C1068.31,809.2,1062.62,801.45,1055,798.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st26",
    d: "M934.44,945.8c49.71-32.76,115.85-33.2,175.31-28.16c0,0,4.82,19.72,4.82,20.53 c-27.44-2.33-58.57-5.55-85.92-3.4c-27.35,2.16-56.34,12.71-78.16,28.5C945.95,956.67,939.52,951.33,934.44,945.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st3",
    d: "M942.94,955.58c49.71-32.76,110.02-32.54,169.47-27.49c0,0,4.18,19.37,4.18,20.18 c-27.44-2.33-56.6-5.37-83.95-3.21c-27.35,2.16-54.71,10.09-76.54,25.88C951.57,964.33,948.02,961.11,942.94,955.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st18",
    d: "M696.55,802.81c16.84-7.42,35.8-6.29,53.57-2.58c40.45,8.46,78.19,29.77,109.31,58.99 c4.81,4.51,9.55,9.33,12.48,16.55c-6.47,7.78-13.78,14.73-23.06,20.86c-9.04-8.63-19.99-14.49-30.89-20.03 c-21.16-10.74-42.85-20.67-65.7-26.1c-22.84-5.43-49.49-13.17-72.23-4.24c-2.69-8.41-1.34-14.13,0.82-22.76 C683.24,813.93,688.93,806.17,696.55,802.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st7",
    d: "M816.32,950.58c-49.71-32.76-114.8-34.23-174.26-29.18c0,0-4.83,19.48-4.83,20.3 c27.44-2.33,60.42-5.3,87.77-3.14s56.47,11.32,78.29,27.11C807.83,959.06,811.24,956.1,816.32,950.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st18",
    d: "M808.61,960.3c-49.71-32.76-110.02-32.54-169.47-27.49c0,0-4.18,19.37-4.18,20.18 c27.44-2.33,56.6-5.37,83.95-3.21s54.71,10.09,76.54,25.88C799.97,969.05,803.53,965.83,808.61,960.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Boy_Bow"
  }, /*#__PURE__*/React.createElement("path", {
    className: "boy_st18",
    d: "M851.73,969.7c-14.03,8.62-30.48,12.62-43.91,13.62c2.02-22.51,8.74-44.58,17.81-63.2 c5.36-7.66,12.54-14.04,19.01-17.44c9.14-5.28,18.94-9.42,28.66-10.08c5.1,5.32,7.4,12.65,9.53,19.7 c0.78,2.58,1.56,5.16,2.34,7.74c0.26,0.86,0.52,1.74,0.48,2.63c-0.05,1.05-0.51,2.03-0.98,2.97 C882.96,929.11,865.75,961.08,851.73,969.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st18",
    d: "M880.46,908.95c1.51,13.59,3.16,27.63,10.05,39.44c9.55,16.37,30.49,28.66,49.35,35.16 c2.21-16.44,2.25-52.9,0.1-53.96c-7.87-20.61-30.89-25.09-47.27-37.16C888.33,897.85,884.75,903.88,880.46,908.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st18",
    d: "M849.34,881.9c-1.41,9.62-0.61,19.56,3.43,29.38c10.18,3.27,21.26,6.32,31.36,2.82 c5.25-1.82,9.76-5.28,13.42-7.63c3.7-6.71,5.45-14.48,4.98-22.13c-0.19-3.12-0.74-6.23-1.81-9.92c-4.14-6-10.38-10.51-17.38-12.57 c-4.24-1.25-8.69-1.6-13.47-2.07C859.27,863.88,851.02,870.47,849.34,881.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st0",
    d: "M893.35,910.22c4.83,5.12,8.91,10.95,12.07,17.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "boy_st0",
    d: "M859.81,914.02c-6.61,6.69-13.38,13.62-16.98,22.31"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Boy_Layer_1",
    className: "boy_st22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy);
export default __webpack_public_path__ + "static/media/boy.1b71176c7ee5bc447908c075e4f52af8.svg";
export { ForwardRef as ReactComponent };